// logger.js - Centralized logging utility

const isDev = process.env.NODE_ENV === 'development';

export const log = (...args) => {
  if (isDev) console.log(...args);
};

export const warn = (...args) => {
  if (isDev) console.warn(...args);
};

export const error = (...args) => {
  if (isDev) console.error(...args);
};

export const info = (...args) => {
  if (isDev) console.info(...args);
};

export const debug = (...args) => {
  if (isDev) console.debug(...args);
}; 